module.exports = __webpack_public_path__ + "fonts/noto-sans-kr-34-900-normal.15586dd.woff2";